<template>
  <v-sheet class="privacy">
    <v-row>
      <v-col>
        <h1 class="mt-10 mb-15 text-center">Privacy Policy</h1>

        <p>
          Please read the following to learn more about our Privacy Policy. By
          visiting Hire Next Generation LLC’s website and any other linked
          pages, features, content, or any other services we offer, you
          acknowledge that you accept the practices and policies outlined in
          this Privacy Policy, and you hereby consent that we will collect, use,
          and share your information in the following ways. Any capitalized
          terms used herein without definition shall have the meaning given to
          them in our Terms of Service.
        </p>

        <p>
          This Privacy Policy covers our (Hire Next Generation LLC and our
          respective affiliates and related entities) treatment of personally
          identifiable information ("Personal Information") that we gather when
          you are accessing or using the Site or Services (collectively, the
          “System”). This policy does not apply to the practices of companies
          that we do not own or control, or to individuals that we do not employ
          or manage. This policy also does not apply to information you choose
          to disclose publicly on the System.
        </p>

        <h3>Personal Information We Collect</h3>

        <p>
          We receive and store any information you provide to us. The types of
          Personal Information collected may include your real name, username,
          email address, IP address, location, browser information, browsing
          history, transactions, your communications to us, and any other
          information necessary for us to provide our services. If you provide
          any third-party account credentials to us, you understand some content
          and/or information in those accounts ("Third Party Account
          Information") may be transmitted into your account with us if you
          authorize such transmissions, and that Third Party Account Information
          transmitted to our Site is covered by this Privacy Policy. You can
          choose not to provide us with certain information, but then you may
          not be able to register with us or to take advantage of some of our
          features.
        </p>

        <h3>Personal</h3>
        <p>
          Information Collect Automatically Whenever you interact with the
          System, we automatically receive and record information on our server
          logs from your browser including, but not limited to, your IP address,
          "cookie" information, device information, certain location
          information, and the page you requested. "Cookies" are identifiers we
          transfer to your device through our web interface that allow certain
          functions to perform as designed within the System, and also to allow
          us to recognize your device and tell us how and when pages in our site
          are visited and by how many people. We may also record the referring
          page or service that linked you to us; other information about the
          type of web browser, computer, platform, related software, and
          settings you are using; any search terms you have entered on the
          System; and other usage activity and data logged by our servers. You
          may be able to change the preferences on your device to prevent or
          limit your device’s acceptance of cookies, but this may prevent you
          from taking advantage of the System’s best features. When we collect
          usage information (such as the numbers and frequency of visitors to
          the System), we only use this data in aggregate form, and not in a
          manner that would identify you personally. For example, this aggregate
          data tells us how often users use parts of the System, so that we can
          make the System appealing to as many users as possible. We may also
          provide this aggregate information to our partners, so that they can
          understand how often people use their services and our System, so that
          they, too, can provide you with an optimal online experience.
        </p>

        <h3>Uses of Personal Information</h3>

        <p>
          We may use the Personal Information we collect for our legitimate
          business purposes, including providing our services and products to
          you, improving the System, improving our customer service, processing
          transactions, marketing purposes, and managing our business needs. We
          do not sell your personal information to third-parties. We may also
          share Personal Information with our affiliates and trusted third
          parties and services, such as Google Analytics.
        </p>

        <h3>Communications</h3>

        <p>
          As part of the System, you may receive communications from us, whether
          by email or other means. We and our agents may send you email, contact
          you, or engage you in other communication that we or they determine
          relate to your use of the System.
        </p>

        <h3>Affiliated Businesses and Third-Parties</h3>

        <p>
          In certain situations, businesses or third-party websites with which
          we are affiliated may sell items or provide services to you through
          the Site (either alone or jointly with us). You can recognize when an
          affiliated business is associated with such a transaction or service,
          and we will share your Personal Information with that affiliated
          business only to the extent that it is related to such transaction or
          service. One such service may include the ability for you to choose to
          automatically transmit Third Party Account Information to your Site
          profile or to automatically transmit information in your Site profile
          to your third-party account. We have no control over the policies and
          practices of any third-party.
        </p>

        <h3>Protecting Us & Others</h3>

        <p>
          We reserve the right to access, read, preserve, and disclose any
          information that we reasonably believe is necessary to comply with law
          or court order; enforce or apply our conditions of use and other
          agreements; or protect the rights, property, or safety of us, our
          employees, our users, or others. This includes exchanging information
          with other companies and organizations for fraud protection and credit
          risk reduction.
        </p>

        <h3>Personal Information Security</h3>

        <p>
          Your account may be protected by a password for your privacy and
          security. If you access your account via a third-party site or
          service, you may have additional or different sign-in protections via
          that third-party site or service. You need to prevent unauthorized
          access to your account and Personal Information by selecting and
          protecting your password and/or other sign-in mechanism appropriately.
          We endeavor to protect the privacy of your account and other Personal
          Information we hold in our records, but we cannot guarantee complete
          security. Unauthorized entry or use, hardware or software failure, and
          other factors, may compromise the security of user information at any
          time. In the event that we believe that the security of your Personal
          Information in our possession or control has been compromised, we will
          notify you of that development in accordance with applicable law. If a
          notification is appropriate, we will endeavor to do so as promptly as
          possible under the circumstances, and, we may do so by email. Using
          the System, you may find links to third-party websites or apps. We are
          not responsible for the privacy policies and/or practices on other
          sites or apps. When linking to another site or app, you should read
          the site or app’s privacy policy. User profile information, including
          without limitation your name, email address, and other information
          ("User Submissions") may be displayed to other users if you chose to
          enter such information on your user profile. Again, any content you
          voluntarily disclose for other users to view on the System is not
          Personal Information; it becomes publicly available and can be
          collected and used by others and may be redistributed through the
          internet and other media channels.
        </p>

        <h3>Your Rights</h3>

        <p>
          In certain circumstances, you have the following rights: the right to
          be told how we use your information and obtain access to your
          information; the right to have your information rectified or erased or
          place restrictions on processing your information; the right to object
          to the processing of your information (e.g., for direct marketing
          purposes); the right to have any information you provided to us on an
          automated basis returned to you in a structured, commonly used and
          machine-readable format, or sent directly to another company, where
          technically feasible (“data portability”); where the processing of
          your information is based on your consent, the right to withdraw that
          consent subject to legal or contractual restrictions; the right to
          object to any decisions based on the automated processing of your
          personal data, including profiling; and the right to lodge a complaint
          with the supervisory authority responsible for data protection matters
          (e.g. in the UK, the Information Commissioner’s Office). If you
          request a copy of your information, you may be required to pay a
          statutory fee. If we hold any information about you that is incorrect
          or if there are any changes to your details, please let us know so
          that we can keep our records accurate and up to date. If you withdraw
          your consent to the use of your personal information for purposes set
          out in our Privacy Policy, we may not be able to provide you with
          access to all or parts of the System. We will retain your personal
          information for the duration of our business relationship and
          afterward for as long as is necessary and relevant for our legitimate
          business purposes, in accordance with applicable laws and regulation.
          In the event we no longer have a legitimate business purpose to retain
          your personal information, we will dispose of it in a secure manner
          (without further notice to you).
        </p>

        <h3>Accessible Personal Information</h3>

        <p>
          Through your user profile, you may access and, in some cases, edit or
          delete the following information you have provided to us. This list
          may change as the System changes: real name, location, username,
          password, email address, and other account and user profile
          information. The information you can view, update, and delete through
          your user profile may change as the System changes. If you have any
          questions about viewing, updating, or removing information we have on
          file about you, please contact us at hireme@hirenextgeneration.com.
        </p>

        <h3>Other Information</h3>

        <p>
          You may opt not to disclose information, but keep in mind that some
          information may be needed to register with us or to take advantage of
          some of our special features. You may be able to add, update, or
          delete certain information as explained above. When you do so,
          however, we may maintain a copy of the unrevised information in our
          records. We may use any aggregated data derived from or incorporating
          your Personal Information after you update or delete it, but not in a
          manner that would identify you personally. You may close your account
          pursuant to the terms of service or subscription agreement that
          applies to you. Please note that some information may remain in our
          private records after the closing of your account. If you do not wish
          to receive email or other mail from us, please email us at
          hireme@hirenextgeneration.com. Please note that if you do not want to
          receive legal notices from us, such as this Privacy Policy, those
          legal notices will still govern your use of the System, and you are
          responsible for reviewing such legal notices for changes.
        </p>

        <h3>California Residents</h3>

        <p>
          Because we value the privacy of California residents, we have taken
          the necessary precautions to be in compliance with the California
          Online Privacy Protection Act as it pertains to us. We will not
          distribute your personal information to parties not mentioned in this
          Privacy Policy without your consent. We cannot guarantee the security
          of your personal information and expressly disclaim any such
          obligation. If we learn of a security breach, we will attempt to
          notify you so that you can take appropriate steps. Please
          <router-link to="ccpa">click here</router-link>
          for our Privacy Notice for California Residents, including information
          related to the California Consumer Privacy Act (CCPA).
        </p>

        <h3>How We Respond to Do Not Track Signals</h3>

        <p>
          Please note that we do not alter our data collection and use practices
          when we see a Do Not Track signal from your browser.
        </p>

        <h3>Access and Use by Minors</h3>

        <p>
          The System is not intended for use by minors under the age of 18. We
          ask that minors not use the System nor submit any personal information
          to us. We do not knowingly collect information from minors under 18.
          In the event that we learn we have collected any personal information
          from a minor under the age of 18, we will take appropriate steps to
          delete that information from our database. If you are a minor under
          the age of 18 and you have acceded to this website, do not provide
          your personal information and please leave this website immediately.
        </p>

        <h3>Changes to this Privacy Policy</h3>

        <p>
          We may amend this Privacy Policy from time to time. Use of information
          we collect now is subject to the Privacy Policy in effect at the time
          such information is used. If we make changes in the way we use
          Personal Information, we will notify you by posting an announcement on
          our System or sending you an email. You are bound by any changes to
          the Privacy Policy when you use the System after such changes have
          been first posted.
        </p>

        <h3>Contact</h3>

        <p>
          If youhave any questions about this privacy policy, you may contact us
          at hireme@hirenextgeneration.com. Privacy Policy Last Updated on
          November 5, 2020
        </p>
      </v-col>
    </v-row>
  </v-sheet>
</template>
<script>
export default {};
</script>

<style></style>
